import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const StudentContext = createContext(null);

export function StudentProvider({ children }) {
  const { user } = useAuth();
  const [students, setStudents] = useState([]);
  const [activeId, setActiveId] = useState(localStorage.getItem("activeStudent") || null);

  useEffect(() => {
    if (user && user.role === "orangtua") {
      api.get("/students").then((r) => {
        setStudents(r.data);
        if (r.data.length && !r.data.find((s) => s.id === activeId)) {
          setActiveId(r.data[0].id);
          localStorage.setItem("activeStudent", r.data[0].id);
        }
      });
    }
    // eslint-disable-next-line
  }, [user]);

  const selectStudent = (id) => {
    setActiveId(id);
    localStorage.setItem("activeStudent", id);
  };

  const active = students.find((s) => s.id === activeId) || students[0] || null;

  return (
    <StudentContext.Provider value={{ students, active, activeId: active?.id, selectStudent }}>
      {children}
    </StudentContext.Provider>
  );
}

export const useStudent = () => useContext(StudentContext);
